// Show form message
export const showFormMessage = (
  form: HTMLFormElement,
  message: string,
  type: 'success' | 'error'
): void => {
  const messageElement = form.querySelector('#form-message') as HTMLElement;
  if (!messageElement) return;

  messageElement.textContent = message;
  messageElement.className = `form-message form-message--${type}`;
  messageElement.setAttribute('aria-live', 'polite');

  // Scroll to message
  messageElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

  // Clear message after 5 seconds
  setTimeout(() => {
    messageElement.textContent = '';
    messageElement.className = 'form-message';
  }, 5000);
};